// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3_2MK";
var _4 = "warning-p7owl";
var _5 = "success-2ZbBl";
var _6 = "error-12lvf";
var _7 = "infoIcon-1dBGW";
var _8 = "close-miftP";
var _9 = "message-1wHLE";
var _a = "title-1wyzB";
var _b = "text-9d5y5";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "warning", _5 as "success", _6 as "error", _7 as "infoIcon", _8 as "close", _9 as "message", _a as "title", _b as "text" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "warning": _4, "success": _5, "error": _6, "infoIcon": _7, "close": _8, "message": _9, "title": _a, "text": _b }
